/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_help_valid_desc = /** @type {(inputs: { count: NonNullable<unknown>, budget: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} teams fit within your $${i?.budget}M budget.`)
};

const es_f1_apex_help_valid_desc = /** @type {(inputs: { count: NonNullable<unknown>, budget: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} equipos caben dentro de tu presupuesto de $${i?.budget}M.`)
};

const de_f1_apex_help_valid_desc = /** @type {(inputs: { count: NonNullable<unknown>, budget: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Teams passen in dein Budget von $${i?.budget}M.`)
};

const nl_f1_apex_help_valid_desc = /** @type {(inputs: { count: NonNullable<unknown>, budget: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} teams passen binnen je budget van $${i?.budget}M.`)
};

const fr_f1_apex_help_valid_desc = /** @type {(inputs: { count: NonNullable<unknown>, budget: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} équipes rentrent dans votre budget de $${i?.budget}M.`)
};

const it_f1_apex_help_valid_desc = /** @type {(inputs: { count: NonNullable<unknown>, budget: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} team rientrano nel tuo budget di $${i?.budget}M.`)
};

const pt_br2_f1_apex_help_valid_desc = /** @type {(inputs: { count: NonNullable<unknown>, budget: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} equipes cabem dentro do seu orçamento de $${i?.budget}M.`)
};

const pt_f1_apex_help_valid_desc = /** @type {(inputs: { count: NonNullable<unknown>, budget: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} equipas cabem dentro do seu orçamento de $${i?.budget}M.`)
};

const ja_f1_apex_help_valid_desc = /** @type {(inputs: { count: NonNullable<unknown>, budget: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}チームが$${i?.budget}Mの予算内に収まります。`)
};

const zh_f1_apex_help_valid_desc = /** @type {(inputs: { count: NonNullable<unknown>, budget: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}支车队符合您$${i?.budget}M的预算。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown>, budget: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_help_valid_desc = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_help_valid_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_help_valid_desc", locale)
	if (locale === "en") return en_f1_apex_help_valid_desc(inputs)
	if (locale === "es") return es_f1_apex_help_valid_desc(inputs)
	if (locale === "de") return de_f1_apex_help_valid_desc(inputs)
	if (locale === "nl") return nl_f1_apex_help_valid_desc(inputs)
	if (locale === "fr") return fr_f1_apex_help_valid_desc(inputs)
	if (locale === "it") return it_f1_apex_help_valid_desc(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_help_valid_desc(inputs)
	if (locale === "pt") return pt_f1_apex_help_valid_desc(inputs)
	if (locale === "ja") return ja_f1_apex_help_valid_desc(inputs)
	return zh_f1_apex_help_valid_desc(inputs)
};